import { useMutation } from '@tanstack/react-query';
import { apiClient, type ApiResponse } from '@/lib/api-client';

/**
 * Result of a postal-code verification call.
 */
export interface PostalCodeVerificationResult {
  valid: boolean;
  postalCode: string;
  country: string;
  places: Array<{ placeName: string; state: string | null; stateCode: string | null }>;
}

export interface VerifyPostalCodeInput {
  /** ISO 3166-1 alpha-2 country code. */
  country: string;
  postalCode: string;
}

/**
 * Verifies a postal code for a country via the backend proxy
 * (POST /address/verify-postal-code). Validation only — does not autofill.
 */
export function useVerifyPostalCode() {
  return useMutation({
    mutationFn: async (input: VerifyPostalCodeInput) => {
      const response = await apiClient.post<ApiResponse<PostalCodeVerificationResult>>(
        '/address/verify-postal-code',
        input,
      );
      return response.data.data;
    },
  });
}
